<template lang="pug">
div
  //- add draggable property in order for the booking card to be draggable again
  .booking-card(
    v-for="(bookingProductKey, bpIndex) in timeslot.BookedProductKeys" 
    :key="bookingProductKey"
    :style="getBookingCardStyle(timeslot)"
    @dragstart="pickupBookingCard($event, bookingProductKey, resourceIndex, timeslotIndex)"
    @dragend="dragEnd()"
    )
    BookingCardContent(
      :bookingProduct="getBookingProduct(bookingProductKey)"
      :bookingProductTime="getBookingProductStartEndTime(bookingProductKey)"
      :timeslot="timeslot"
      :timeslotIndex="timeslotIndex"
      )
</template>
<script>
import { propEq, find } from 'ramda'
import { mapActions, mapGetters } from 'vuex'
import { formatTimeFromUtc } from '@/helpers/dateTimeFormatter.js'
import BookingCardContent from '@/vue/planboard/planboard-calendar/BookingCardContent.vue'
import { getBookingCardHeight } from '@/vue/planboard/planboard-calendar/planboardCalendarUtil.js'

export default {
  name: 'BookingCard',
  components: {
    BookingCardContent,
  },
  props: {
    timeslotIndex: Number,
    timeslot: Object,
    resourceIndex: Number,
    resource: Object,
  },
  methods: {
    ...mapActions('planboardModule', ['setDragInProgress']),
    getBookingProduct(bpKey) {
      return find(propEq('BookingProductKey', bpKey))(this.resource.BookingProducts)
    },
    getBookingProductStartEndTime(bpKey) {
      const bp = this.getBookingProduct(bpKey)
      const startTime = formatTimeFromUtc(this.$locale)(this.$timezone)(bp.StartTime)
      const endTime = formatTimeFromUtc(this.$locale)(this.$timezone)(bp.EndTime)
      return `${startTime} - ${endTime}`
    },
    getBookingCardStyle(timeslot) {
      return `height: ${getBookingCardHeight(timeslot)}px;`
    },
    pickupBookingCard(e, bookingProductKey, fromResourceIndex, fromTimeslotIndex) {
      this.setDragInProgress(true)
      e.dataTransfer.effectAllowed = 'move'
      e.dataTransfer.dropEffect = 'move'

      e.dataTransfer.setData('booking-card-key', bookingProductKey)
      e.dataTransfer.setData('from-resource-index', fromResourceIndex)
      e.dataTransfer.setData('from-timeslot-index', fromTimeslotIndex)
    },
    dragEnd(_e) {
      this.setDragInProgress(false)
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

.booking-card
  background-color white
  border-radius 3px
  border-color grey300
  width 214px
  //- disable drag&drop for first version
  // cursor grab
  margin-left 2px
  position absolute
  border-width 1px
  border-style solid
  margin-top 3px
</style>
